import { InjectionToken } from '@angular/core';

export const SignalRStartupToken = new InjectionToken<Promise<any>>('SignalRStartup');
